export default __webpack_public_path__ + "static/media/run-buddy.21e516ae.png";